import{broadcastToChild as o}from"./broadcast2child.js";import{broadcastToParent as r}from"./broadcast2parent.js";function t(t,a){"child"!==t?r(a):o(a)}export{t as broadcast};
//# sourceMappingURL=broadcast.js.map
